import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=5bdb9a12&scoped=true&"
import script from "./AddProject.vue?vue&type=script&lang=js&"
export * from "./AddProject.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddProject.vue?vue&type=style&index=1&id=5bdb9a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb9a12",
  null
  
)

export default component.exports